import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../lib/utils";

/**
 * DarkInfoPanel — Industrial Display Primitive (F3, TES-950)
 *
 * Dunkles Info-Panel mit Header-Slot + Key/Value-Rows (Stitch screen-07:310-340).
 * REINE UI-HUELLE — KEIN SAP-Sync-Call, keine Datenanbindung. Das Mock-Vokabular
 * (SAP/Q-Meldung) ist nur Anzeige-Label, keine CheckMaty-Entitaet (INVENTORY §279).
 *
 * Mock text-on-tertiary -> real text-tertiary-container-foreground (Token existiert).
 *   - tertiary (Default) bg-tertiary-container (SAP-Sync-Panel, screen-07:311)
 *   - primary            bg-primary text-primary-foreground (Inspector-Log-Variante)
 */
const darkInfoPanelVariants = cva("p-6 rounded-xl", {
  variants: {
    tone: {
      tertiary: "bg-tertiary-container text-tertiary-container-foreground",
      primary: "bg-primary text-primary-foreground",
    },
  },
  defaultVariants: {
    tone: "tertiary",
  },
});

interface DarkInfoPanelRow {
  id: string;
  label: React.ReactNode;
  value: React.ReactNode;
}

interface DarkInfoPanelProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof darkInfoPanelVariants> {
  /** Header-Slot (Titel + ggf. Status-Pill), i18n vom Aufrufer. */
  header?: React.ReactNode;
  /** Key/Value-Zeilen (i18n vom Aufrufer). */
  rows?: DarkInfoPanelRow[];
}

const DarkInfoPanel = React.forwardRef<HTMLDivElement, DarkInfoPanelProps>(
  ({ className, tone, header, rows, children, ...props }, ref) => (
    <div ref={ref} className={cn(darkInfoPanelVariants({ tone }), className)} {...props}>
      {header !== undefined && (
        <div className="flex justify-between items-center mb-6">{header}</div>
      )}
      {rows !== undefined && rows.length > 0 && (
        <dl className="space-y-4">
          {rows.map((row) => (
            <div key={row.id} className="flex justify-between gap-4 border-b border-white/10 pb-2">
              <dt className="opacity-80">{row.label}</dt>
              <dd className="text-data-tabular font-bold text-right">{row.value}</dd>
            </div>
          ))}
        </dl>
      )}
      {children}
    </div>
  ),
);
DarkInfoPanel.displayName = "DarkInfoPanel";

export { DarkInfoPanel };
